import React from 'react'

export default function Arrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.34 11.27">
      <title>arrow</title>
      <g id="Слой_2" data-name="Слой 2">
      <g id="Layer_1" data-name="Layer 1">
        <polygon points="11.71 0 10.29 1.41 13.52 4.64 0 4.64 0 6.64 13.52 6.64 10.29 9.86 11.71 11.27 17.34 5.64 11.71 0"></polygon>
      </g>
      </g>
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/img/arrow.jsx